module.exports = __webpack_public_path__ + "img/ic_dustbin.3db3673f.svg";